export const STRONG_PASSWORD_MESSAGE = '密码长度不能少于8位，且必须同时包含字母和数字';

/**
 * 密码必须至少 8 位，且同时包含英文字母和数字。
 * 不对传入值进行 trim，空格属于密码本身的一部分。
 */
export function isStrongPassword(password) {
    return typeof password === 'string'
        && password.length >= 8
        && /[A-Za-z]/.test(password)
        && /[0-9]/.test(password);
}

/**
 * 与 Form.Item required 规则搭配使用的校验器。
 */
export function validateStrongPassword(_, value) {
    if (!value || isStrongPassword(value)) {
        return Promise.resolve();
    }

    return Promise.reject(new Error(STRONG_PASSWORD_MESSAGE));
}
